import React, { useEffect, useState } from "react";
import "./supereditform.css";
// eslint-disable-next-line
import PersonIcon from "@mui/icons-material/Person";
import avatars from "../../Global/avtar";
// eslint-disable-next-line
import {KeyboardArrowDownSharp,KeyboardArrowUpSharp,
} from "@mui/icons-material";
// import Select from '@mui/material/Select';
// import MenuItem from '@mui/material/MenuItem';
import { toast } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { handleToast } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { getLanguages } from "../../../services/api/languages";
import { update_Admin } from "../../../services/api/admin";

export default function SuperEditForm({ data, edit2 }) {
  const [name, setName] = useState(data.name);
  // eslint-disable-next-line
  const [language, setLanguage] = useState(data?.app_language || "NA");
  // eslint-disable-next-line
  const [setAppLanguage] = useState([]);
  const [img, setImg] = useState(data.photo);
  // eslint-disable-next-line
  const [imagediv, setImagediv] = useState(true);
  // eslint-disable-next-line
  const [up, setUp] = useState(false);
  // eslint-disable-next-line
  const [down, setDown] = useState(false);
  const IsTrue = false;
  const [loader, setLoder] = useState(false);
  const [email, setEmail] = useState(data.email);
  const [edit, setEdit] = useState(edit2);
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 600;

  // const handlePassword=(e)=>{
  //   const newValue=e.target.value;
  //   setPassword(newValue);
  // }

  const submit = async (e) => {
    setEdit(false);
    const form = new FormData();
    e.preventDefault();
    const admin = {
      id: data.id,
      name: name,
      role: "admin",
      // app_language: language,
      email: email,
      photo: img,
      // SK: data?.SK,
      // PK: data?.PK,
    };
    Object.keys(admin).forEach((key) => {
      form.append(key, admin[key]);
    });

    if (!edit) {
      setLoder(true);
      try {
        update_Admin(form)
          .then((response) => {
            if (response.data.status === "success") {
              toast.success("Success! Edit", {
                position: isMobile ? "top-left" : "top-center",
                style: {
                  width: isMobile ? "300px" : "400px",
                  textWrap: isMobile && "wrap",
                },
              });
              setLoder(false);
              navigate("/admin/super_admin");
            }
          })

          .catch((error) => {
            handleToast(error?.response?.data);
            setLoder(false);
            return;
          });
      } catch (error) {
        handleToast(error?.response?.data);
        console.log(error);
        return;
      }
    }
  };

  const fetchLanguageList = async () => {
    getLanguages()
      .then((response) => {
        if (response.data.status === "success") {
          const appLanguages = [];
          response?.data?.data.forEach((element) => {
            if (element.app_language === true) {
              appLanguages.push(element);
            }
          });
          setAppLanguage(appLanguages);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  useEffect(() => {
    setImg(avatars[0].image);
    fetchLanguageList();
  }, []);

  const remove = (e) => {
    e.preventDefault();
    navigate("/admin/super_admin");
  };
  // eslint-disable-next-line
  const handleDropdown = () => {
    setDown((prev) => !prev);
    setUp((prev) => !prev);
  };

  return (
    <div className="form2">
      {!loader ? (
        <div className="form2">
          <form onSubmit={submit} action="" style={{ height: "300px" }}>
            <div className="input-type">
              <h3>
                Name <sup>*</sup>
              </h3>
              <input
                type="text"
                placeholder="Enter  Your Name"
                required
                value={name}
                disabled={edit}
                onChange={(e) => {
                 const newValue = e.target.value;
                 if (/^[A-Za-z\s]*$/.test(newValue)) {
                    setName(newValue);
                 }
                }}
                style={{
                  cursor: edit && "not-allowed",
                  width: "100%",
                }}
              />
            </div>

            <div
              className="mincont"
              style={{ display: "flex", gap: "10px", width: "100%" }}
            >
              {/* <div className="input-type">
                <h3>Password <sup>*</sup></h3>
                <input  
                  type="tel"  
                  placeholder='Enter  Your Password'  
                  value={Password}  
                  onChange={handlePassword} 
                  style={{
                    cursor : edit && 'not-allowed',
                    width:'100%'
                    }}  
                  maxLength='10' 
                  disabled={edit} 
                />
            </div> */}
              <div className="input-type">
                <h3>
                  Email <sup>*</sup>
                </h3>
                <input
                  type="email"
                  placeholder="Enter Email"
                  disabled
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  style={{
                    cursor: edit && "not-allowed",
                    width: "100%",
                  }}
                  required
                />
              </div>
            </div>
            <div className="submit">
              {!edit && (
                <button
                  className="btn1"
                  style={{
                    outline: IsTrue ? "none" : " 1px solid var(--admin-page--color)",
                    color: IsTrue ? "#1c1c1c6d" : "var(--admin-page--color)",
                    background: IsTrue ? "rgba(63, 61, 61, 0.07)" : "#FFFFFF",
                  }}
                  onClick={remove}
                  type="button"
                >
                  DISCARD EDIT
                </button>
              )}
              <button
                className="btn2"
                style={{
                  outline: edit ? "none" : " 1px solid var(--admin-page--color)",
                  color: edit ? "#FFFF" : "#FFFF",
                  background: edit ? "var(--admin-page--color)" : " var(--admin-page--color)",
                }}
                type="submit"
              >
                {edit ? "EDIT" : "SAVE CHANGES"}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="loader">
          <CircularProgress style={{ color: "var(--admin-page--color)" }} />
        </div>
      )}
    </div>
  );
}
